import { render, staticRenderFns } from "./AdminHollidaysView.vue?vue&type=template&id=3a5efed9&scoped=true&"
import script from "./AdminHollidaysView.vue?vue&type=script&lang=js&"
export * from "./AdminHollidaysView.vue?vue&type=script&lang=js&"
import style0 from "./AdminHollidaysView.vue?vue&type=style&index=0&id=3a5efed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5efed9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
